<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title>{{$t('products.scheduling_details')}}</v-toolbar-title>
    </v-toolbar>
    <v-divider/>
    <v-card-text>
      <v-row>
        <v-col
          cols="12"
          xs="12"
          md="3"
        >
          <v-text-field
            v-model.number="model.startPadding"
            outlined
            dense
            label="Start Padding (Minutes)"
            type="number"
          />
        </v-col>
        <v-col
          cols="12"
          xs="12"
          md="6"
        >
          <v-text-field
            v-model.number="model.duration"
            outlined
            dense
            label="Duration (Minutes)"
            type="number"
          />
        </v-col>
        <v-col
          cols="12"
          xs="12"
          md="3"
        >
          <v-text-field
            v-model.number="model.endPadding"
            outlined
            dense
            label="End Padding (Minutes)"
            type="number"
          />
        </v-col>
      </v-row>
<!--      <v-row>-->
<!--        <v-col-->
<!--          cols="12"-->
<!--          xs="12"-->
<!--          md="6"-->
<!--        >-->
<!--          <amount-input-->
<!--            :label="'Required Deposit'"-->
<!--            :init-amount="parseInt(product.deposit, 10)"-->
<!--            @change="onChangeDeposit($event)"-->
<!--          />-->
<!--        </v-col>-->
<!--      </v-row>-->

<!--      <v-row>-->
<!--        <v-col-->
<!--          cols="12"-->
<!--          xs="12"-->
<!--          md="6"-->
<!--        >-->
<!--          <v-text-field-->
<!--            v-model.number="model.notifyMinutes"-->
<!--            outlined-->
<!--            dense-->
<!--            label="Pre-Booking Notification (Minutes)"-->
<!--            type="number"-->
<!--          />-->
<!--        </v-col>-->
<!--        <v-col-->
<!--          cols="12"-->
<!--          xs="12"-->
<!--          md="6"-->
<!--        >-->
<!--          <v-checkbox-->
<!--            v-model="model.notifyTypes.email"-->
<!--            class="mt-0"-->
<!--            :label="`Email`"-->
<!--            hide-details-->
<!--          />-->
<!--          <v-checkbox-->
<!--            v-model="model.notifyTypes.sms"-->
<!--            :disabled="true"-->
<!--            :label="`SMS (Coming soon)`"-->
<!--            hide-details-->
<!--          />-->
<!--        </v-col>-->
<!--      </v-row>-->
    </v-card-text>
  </v-card>
</template>
<script>
import AmountInput from "../Common/AmountInput"
import { get } from 'lodash'

export default {
  components: { AmountInput },
  props: {
    product: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    model: {
      deep: true,
      handler() {
        this.$emit('change', this.model)
      }
    }
  },
  methods: {
    onChangeDeposit(val){
      this.model.deposit = val
    }
  },
  data() {
    return {
      model: {
        duration: parseInt(get(this.product, 'duration', 0)),
        deposit: parseInt(get(this.product, 'deposit', 0)),
        endPadding: parseInt(get(this.product, 'endPadding', 0)),
        startPadding: parseInt(get(this.product, 'startPadding', 0)),
        notifyMinutes: parseInt(get(this.product, 'notifyMinutes', 0)),
        notifyTypes: {
          email: get(this.product, 'notifyTypes.email', true),
          sms: get(this.product, 'notifyTypes.sms', false),
        }
      }
    }
  }
}
</script>
